import { Layers } from 'lucide-react';
import { ModeConfig } from './types';

export const modes: ModeConfig[] = [
  { 
    id: 'pm', 
    label: 'Product Manager', 
    icon: Layers, 
    color: 'text-indigo-600', 
    theme: 'bg-white text-slate-900 selection:bg-indigo-100',
    design: {
      bg: 'bg-white',
      textPrimary: 'text-slate-900',
      textSecondary: 'text-slate-500',
      accent: 'text-indigo-600',
      border: 'border-slate-200',
      cardBg: 'bg-slate-50',
      cardBorder: 'border-slate-200',
      fontFamily: 'sans',
      borderRadius: 'rounded-lg',
      shadow: 'shadow-sm',
      effects: ['grid-pattern']
    }
  },
];
